var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
  _vm.$store.state.app.view_pattern + '_pattern',
  _vm.$store.state.app.language == 'zh-cn' ? 'chinese_station' : 'foreign_station',
  _vm.$store.state.app.road_type == 1 ? 'foreign_trade_station' : 'domestic_station',
  _vm.isFullPage?'is-full-page':'',
  'web_language_wm_' + _vm.$store.state.app.web_language_wm
  ],style:({'--theme_color': _vm.theme_color}),attrs:{"id":"app"}},[_c('router-view',{key:_vm.$route.fullPath}),_vm._v(" "),(_vm.$store.state.color.isShow)?[_c('my_color_picker'),_vm._v(" "),_c('div',{staticClass:"my_color_picker_mongolia",on:{"click":function (){_vm.$store.commit('color/isShow_change',false)}}})]:_vm._e(),_vm._v(" "),(_vm.$store.state.preview.isShow)?_c('preview'):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cc704ec","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 